var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tbody',{staticClass:"table-drag-select",on:{"mousedown":_vm.onMouseDown}},[_vm._t("default",null,{"selectedItems":_vm.selectedItems}),(_vm.mouseDown)?_c('div',{staticClass:"table-drag-select-box",style:(_vm.selectionBoxStyling)}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }